import SimpleButton from './SimpleButton'
import InteractiveSimpleButton from './InteractiveSimpleButton'

export default SimpleButton
export {
  InteractiveSimpleButton
}



// WEBPACK FOOTER //
// ./src/app/components/common/simpleButton/index.js